var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfidential(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#4909AA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 9H16.375V7.57143C16.375 5.6 14.415 4 12 4C9.585 4 7.625 5.6 7.625 7.57143V9H6.75C5.7875 9 5 9.64286 5 10.4286V17.5714C5 18.3571 5.7875 19 6.75 19H17.25C18.2125 19 19 18.3571 19 17.5714V10.4286C19 9.64286 18.2125 9 17.25 9ZM12 15.4286C11.0375 15.4286 10.25 14.7857 10.25 14C10.25 13.2143 11.0375 12.5714 12 12.5714C12.9625 12.5714 13.75 13.2143 13.75 14C13.75 14.7857 12.9625 15.4286 12 15.4286ZM9.375 9V7.57143C9.375 6.38571 10.5475 5.42857 12 5.42857C13.4525 5.42857 14.625 6.38571 14.625 7.57143V9H9.375Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfidential);
export default __webpack_public_path__ + "static/media/confidential.f1f9d2f730c4c3aaeab289c13c41603f.svg";
export { ForwardRef as ReactComponent };